import React, { useEffect } from "react";
/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import { motion } from "framer-motion";

// load bayc images
import bayc1 from "../../assets/placeholder/nfts/bayc_01.png";
import bayc2 from "../../assets/placeholder/nfts/bayc_02.png";
import bayc3 from "../../assets/placeholder/nfts/bayc_03.png";
import bayc4 from "../../assets/placeholder/nfts/bayc_04.png";

// load degods images
import degods1 from "../../assets/placeholder/nfts/degod_01.png";
import degods2 from "../../assets/placeholder/nfts/degod_02.png";
import degods3 from "../../assets/placeholder/nfts/degod_03.png";
import degods4 from "../../assets/placeholder/nfts/degod_04.png";

// load pp images
import pp1 from "../../assets/placeholder/nfts/pp_01.png";
import pp2 from "../../assets/placeholder/nfts/pp_02.png";
import pp3 from "../../assets/placeholder/nfts/pp_03.png";
import pp4 from "../../assets/placeholder/nfts/pp_04.png";


function WhiteListedCollectionsHome({ children, onClick }: any) {
  return <NftImage onClick={onClick}>{children} </NftImage>;
}

const NftImage = ({ children, onClick }: any) => {
  let [isHoverRight, setIsHoverRight] = React.useState(false);
  let [isHoverLeft, setIsHoverLeft] = React.useState(false);
  let [currentState, setCurrentState] = React.useState("state1");

  let [imageArray, setImageArray] = React.useState<any>([]);

  useEffect(() => {
    if (currentState == "state1") {
      setImageArray([bayc1, bayc4, bayc2, bayc3]);
    } else if (currentState == "state2") {
      setImageArray([degods1, degods2, degods3, degods4]);
    } else if (currentState == "state3") {
      setImageArray([pp1, pp2, pp3, pp4]);
    }
  }, [currentState]);

  const handleNextBtn = () => {
    if (currentState == "state1") {
      setCurrentState("state2");
    } else if (currentState == "state2") {
      setCurrentState("state3");
    } else if (currentState == "state3") {
      setCurrentState("state1");
    }
  };

  const handlePreviousBtn = () => {
    if (currentState == "state1") {
      setCurrentState("state3");
    } else if (currentState == "state2") {
      setCurrentState("state1");
    } else if (currentState == "state3") {
      setCurrentState("state2");
    }
  };

  return (
    <div
      onClick={onClick}
      css={css`
        display: flex;
        width: 502px;
        height: 584px;
        position: relative;
        overflow: hidden;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        z-index: 1;
      `}
    >
      <div
        css={css`
          display: flex;
          width: 60%;
          top: 5%;
          left: 15%;
          position: absolute;
        `}
      >
        <svg
          viewBox="0 0 372 415"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          xlinkHref="http://www.w3.org/1999/xlink"
        >
          <mask
            id="mask0_3933_36627"
            css={css`
              mask-type: alpha;
            `}
            maskUnits="userSpaceOnUse"
            x="0"
            y="0"
            width="372"
            height="415"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M219.175 4.30589C283.814 21.1522 284.955 109.218 317.229 167.76C338.481 206.31 376.033 237.067 371.647 280.879C366.638 330.916 338.593 378.414 293.854 401.28C248.026 424.703 194.896 415.004 147.242 395.573C94.5012 374.068 44.1622 343.798 23.0386 290.856C-2.82045 226.045 -13.3364 149.448 26.0694 91.8771C68.0936 30.4809 147.227 -14.4455 219.175 4.30589Z"
              fill="#C4C4C4"
            />
          </mask>
          <g mask="url(#mask0_3933_36627)">
            <rect
              x="-29"
              y="-1"
              width="442"
              height="422"
              fill="url(#patternMain0)"
            />
          </g>
          <defs>
            <pattern
              id="patternMain0"
              patternContentUnits="objectBoundingBox"
              width="1"
              height="1"
            >
              <use xlinkHref="#image_01" />
            </pattern>
            <image
              width="1"
              height="1"
              id="image_01"
              xlinkHref={imageArray[0]}
            ></image>
          </defs>
        </svg>
      </div>
      <div
        css={css`
          display: flex;
          width: 100%;
          margin-top: auto;
        `}
      >
        <motion.svg
          width="100%"
          height="auto"
          viewBox="0 0 650 426"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          xmlnsXlink="http://www.w3.org/1999/xlink"
        >
          <g clip-path="url(#clip0_3933_36625)">
            <rect
              width="216"
              height="216"
              transform="translate(0 141)"
              fill="white"
            />
            <g
              css={css`
                mix-blend-mode: darken;
              `}
            >
              <rect
                width="281"
                height="281"
                transform="translate(-32 108)"
                fill="white"
              />
              {/* left image items */}
              <g filter="url(#filter0_f_3933_36625)">
                <motion.circle
                  cx="85"
                  cy="280"
                  r="69"
                  fill="black"
                  animate={currentState}
                  variants={{
                    state1: { cx: 95, cy: 280, r: 69 },
                    state2: { cx: 65, cy: 280, r: 69 },
                    state3: { cx: 490.5 - 430, cy: 266.5 + 40, r: 53.5 },
                  }}
                />
                <motion.circle
                  cx="51.2989"
                  cy="51.2989"
                  r="51.2989"
                  fill="black"
                  animate={currentState}
                  variants={{
                    state1: { cx: 70.2989, cy: 231.2989, r: 51.2989 },
                    state2: { cx: 60.2989, cy: 190.2989, r: 45.2989 },
                    state3: {
                      cx: 470.1593 - 430,
                      cy: 183.1593 + 40,
                      r: 28.1593,
                    },
                  }}
                />
                <motion.circle
                  cx="58.61"
                  cy="58.61"
                  r="58.61"
                  fill="black"
                  animate={currentState}
                  variants={{
                    state1: { cx: 118.61, cy: 198.61, r: 58.61 },
                    state2: { cx: 158.61, cy: 220.61, r: 58.61 },
                    state3: {
                      cx: 538.9914 - 430,
                      cy: 175.9914 + 40,
                      r: 68.9914,
                    },
                  }}
                />
                <motion.circle
                  cx="76.441"
                  cy="215.344"
                  r="40.5328"
                  fill="black"
                  animate={currentState}
                  variants={{
                    state1: { cx: 166.441, cy: 250.344, r: 42.5328 },
                    state2: { cx: 156.441, cy: 310.344, r: 42.5328 },
                    state3: {
                      cx: 599.441 - 430,
                      cy: 240.344 + 40,
                      r: 44.5328,
                    },
                  }}
                />
                <g
                  css={css`
                    mix-blend-mode: hue;
                  `}
                >
                  <circle
                    cx="84.2545"
                    cy="84.2545"
                    r="61.4145"
                    transform="matrix(0.894157 -0.447754 -0.447754 -0.894157 -109.495 213.94)"
                    stroke="#AEAEAE"
                    stroke-width="45.6799"
                  />
                </g>
              </g>
              <g
                css={css`
                  mix-blend-mode: color-dodge;
                `}
              >
                <rect
                  x="-261.6"
                  y="-123.773"
                  width="746.667"
                  height="746.667"
                  fill="#878787"
                />
              </g>
              <g
                css={css`
                  mix-blend-mode: color-burn;
                `}
              >
                <rect
                  x="-261.6"
                  y="-123.773"
                  width="746.667"
                  height="746.667"
                  fill="black"
                />
              </g>
              <g
                css={css`
                  mix-blend-mode: screen;
                `}
              >
                <rect
                  x="1"
                  y="140"
                  width="216"
                  height="218"
                  fill="url(#pattern0)"
                />
              </g>
            </g>
          </g>
          <g clip-path="url(#clip1_3933_36625)">
            <rect
              width="216"
              height="216"
              transform="translate(217 210)"
              fill="white"
            />
            <g
              css={css`
                mix-blend-mode: darken;
              `}
            >
              <rect
                width="281"
                height="282"
                transform="translate(185 177)"
                fill="white"
              />
              {/* middle image items */}
              <g filter="url(#filter1_f_3933_36625)">
                <motion.circle
                  cx="286.187"
                  cy="342.581"
                  r="62.815"
                  fill="black"
                  animate={currentState}
                  variants={{
                    state1: {
                      cx: 374.187,
                      cy: 352.581,
                      r: 62.815,
                    },
                    state2: { cx: 490.5 - 210, cy: 266.5 + 100, r: 53.5 },
                    state3: { cx: 70 + 220, cy: 280 + 60, r: 69 },
                  }}
                />
                <motion.circle
                  cx="51.2989"
                  cy="51.2989"
                  r="51.2989"
                  fill="black"
                  animate={currentState}
                  variants={{
                    state1: {
                      cx: 301.2989,
                      cy: 291.2989,
                      r: 51.2989,
                    },
                    state2: {
                      cx: 470.1593 - 210,
                      cy: 183.1593 + 100,
                      r: 28.1593,
                    },
                    state3: {
                      cx: 60.2989 + 220,
                      cy: 200.2989 + 60,
                      r: 45.2989,
                    },
                  }}
                />
                <motion.circle
                  cx="68.9914"
                  cy="68.9914"
                  r="68.9914"
                  fill="black"
                  animate={currentState}
                  variants={{
                    state1: {
                      cx: 328.9914,
                      cy: 275.9914,
                      r: 68.9914,
                    },
                    state2: {
                      cx: 538.9914 - 210,
                      cy: 175.9914 + 100,
                      r: 68.9914,
                    },
                    state3: { cx: 138.61 + 220, cy: 220.61 + 60, r: 58.61 },
                  }}
                />
                <motion.circle
                  cx="293.441"
                  cy="304.344"
                  r="40.5328"
                  fill="black"
                  animate={currentState}
                  variants={{
                    state1: {
                      cx: 275.441,
                      cy: 350.581,
                      r: 55.5328,
                    },
                    state2: {
                      cx: 599.441 - 210,
                      cy: 240.344 + 100,
                      r: 44.5328,
                    },
                    state3: { cx: 156.441 + 220, cy: 300.344 + 60, r: 42.5328 },
                  }}
                />
                <g
                  css={css`
                    mix-blend-mode: hue;
                  `}
                >
                  <circle
                    cx="84.2545"
                    cy="84.2545"
                    r="61.4145"
                    transform="matrix(0.894157 -0.447754 -0.447754 -0.894157 107.505 282.94)"
                    stroke="#AEAEAE"
                    stroke-width="45.6799"
                  />
                </g>
              </g>
              <g
                css={css`
                  mix-blend-mode: color-dodge;
                `}
              >
                <rect
                  x="-44.6"
                  y="-54.7732"
                  width="746.667"
                  height="746.667"
                  fill="#878787"
                />
              </g>
              <g
                css={css`
                  mix-blend-mode: color-burn;
                `}
              >
                <rect
                  x="-44.6"
                  y="-54.7732"
                  width="746.667"
                  height="746.667"
                  fill="black"
                />
              </g>
              <g
                css={css`
                  mix-blend-mode: screen;
                `}
              >
                <rect
                  x="209"
                  y="196.697"
                  width="239.952"
                  height="242.289"
                  fill="url(#pattern1)"
                />
              </g>
            </g>
          </g>
          <g clip-path="url(#clip2_3933_36625)">
            <rect
              width="216"
              height="216"
              transform="translate(434 105)"
              fill="white"
            />
            <g
              css={css`
                mix-blend-mode: darken;
              `}
            >
              <rect
                width="281"
                height="281"
                transform="translate(402 72)"
                fill="white"
              />
              {/* right image items */}
              <g filter="url(#filter2_f_3933_36625)">
                <motion.circle
                  cx="518.5"
                  cy="266.5"
                  r="53.5"
                  fill="black"
                  animate={currentState}
                  variants={{
                    state1: { cx: 490.5, cy: 266.5, r: 53.5 },
                    state2: { cx: 65 + 470, cy: 280 - 30, r: 69 },
                    state3: {
                      cx: 374.187 + 215,
                      cy: 352.581 - 90,
                      r: 62.815,
                    },
                  }}
                />
                <motion.circle
                  cx="43.1593"
                  cy="43.1593"
                  r="43.1593"
                  fill="black"
                  animate={currentState}
                  variants={{
                    state1: { cx: 470.1593, cy: 183.1593, r: 28.1593 },
                    state2: {
                      cx: 65.2989 + 470,
                      cy: 231.2989 - 30,
                      r: 51.2989,
                    },
                    state3: {
                      cx: 301.2989 + 215,
                      cy: 291.2989 - 90,
                      r: 51.2989,
                    },
                  }}
                />
                <motion.circle
                  cx="68.9914"
                  cy="68.9914"
                  r="68.9914"
                  fill="black"
                  animate={currentState}
                  variants={{
                    state1: { cx: 538.9914, cy: 175.9914, r: 68.9914 },
                    state2: { cx: 78.61 + 470, cy: 198.61 - 30, r: 58.61 },
                    state3: {
                      cx: 328.9914 + 215,
                      cy: 275.9914 - 90,
                      r: 68.9914,
                    },
                  }}
                />
                <motion.circle
                  cx="519.441"
                  cy="198.344"
                  r="40.5328"
                  fill="black"
                  animate={currentState}
                  variants={{
                    state1: { cx: 599.441, cy: 240.344, r: 44.5328 },
                    state2: {
                      cx: 136.441 + 470,
                      cy: 250.344 - 30,
                      r: 42.5328,
                    },
                    state3: {
                      cx: 275.441 + 215,
                      cy: 350.581 - 90,
                      r: 55.5328,
                    },
                  }}
                />
                <g
                  css={css`
                    mix-blend-mode: hue;
                  `}
                >
                  <circle
                    cx="84.2545"
                    cy="84.2545"
                    r="61.4145"
                    transform="matrix(0.894157 -0.447754 -0.447754 -0.894157 323.505 176.94)"
                    stroke="#AEAEAE"
                    stroke-width="45.6799"
                  />
                </g>
              </g>
              <g
                css={css`
                  mix-blend-mode: color-dodge;
                `}
              >
                <rect
                  x="172.4"
                  y="-159.773"
                  width="746.667"
                  height="746.667"
                  fill="#878787"
                />
              </g>
              <g
                css={css`
                  mix-blend-mode: color-burn;
                `}
              >
                <rect
                  x="172.4"
                  y="-159.773"
                  width="746.667"
                  height="746.667"
                  fill="black"
                />
              </g>
              <g
                css={css`
                  mix-blend-mode: screen;
                `}
              >
                <rect
                  x="439"
                  y="105"
                  width="214"
                  height="216"
                  fill="url(#pattern2)"
                />
              </g>
            </g>
          </g>

          {/* right nav button */}
          <motion.path
            opacity="0.4"
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M583 13.4997C599.069 13.7024 599.5 21.4999 603 28.4999C605.5 38.9999 609.975 50.2499 598.998 58.4017C587.396 67.0169 578 68 569.5 51.9999C561 35.9998 548.5 30.4996 548.5 19.4998C548.5 8.49993 566.306 13.2892 583 13.4997Z"
            fill="#A29B8B"
            // animation on hover
            // animate={{
            //   scale: [1, 1.2, 1.2, 1, 1],
            //   rotate: [0, 0, 270, 270, 0],
            //   borderRadius: ["20%", "20%", "50%", "50%", "20%"],
            // }}
            // transition={{
            //   duration: 2,
            //   ease: "easeInOut",
            //   times: [0, 0.2, 0.5, 0.8, 1],
            //   loop: Infinity,
            // }}
            animate={isHoverRight ? "hover" : "notHover"}
            variants={{
              hover: {
                scale: 1.2,
                rotate: 30,
              },
              notHover: { scale: 1, rotate: 0 },
            }}
            // trigger="hover"
          />
          <motion.path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M604.939 32.1168C605.847 45.2309 596.516 58.4641 583.29 60.8256C572.572 62.7391 569.241 48.4671 563.275 39.5557C558.736 32.7774 550.907 25.882 555.289 19.0057C560.236 11.2422 570.967 10.9237 579.999 13.3089C591.205 16.2681 604.155 20.7949 604.939 32.1168Z"
            fill="#191414"
            animate={isHoverRight ? "hover" : "notHover"}
            variants={{
              hover: {
                scale: 1.1,
                rotate: 40,
              },
              notHover: { scale: 1, rotate: 0 },
            }}
            onMouseEnter={() => setIsHoverRight(true)}
            onMouseLeave={() => setIsHoverRight(false)}
            onClick={handleNextBtn}
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M578.629 41.4918C578.358 41.0109 578.527 40.4009 579.008 40.1293C580.51 39.2814 581.687 38.3899 582.474 37.6224C582.868 37.2374 583.146 36.9016 583.318 36.6355C583.436 36.4532 583.478 36.3446 583.492 36.3014C583.485 36.2792 583.471 36.2445 583.448 36.196C583.387 36.0663 583.284 35.8948 583.134 35.6847C582.834 35.2653 582.401 34.7702 581.898 34.262C580.882 33.2336 579.703 32.2732 578.999 31.8654C578.521 31.5886 578.358 30.9768 578.635 30.4989C578.912 30.021 579.523 29.8579 580.001 30.1347C580.922 30.6681 582.244 31.7665 583.321 32.8558C583.865 33.4064 584.377 33.9848 584.761 34.5213C584.952 34.7891 585.126 35.0661 585.255 35.339C585.377 35.5962 585.5 35.9317 585.5 36.2942C585.5 36.8205 585.256 37.3216 584.998 37.7213C584.721 38.15 584.335 38.6009 583.87 39.0542C582.938 39.9631 581.615 40.954 579.992 41.8708C579.511 42.1424 578.901 41.9727 578.629 41.4918Z"
            fill="#CCC4B3"
          />
          {/* left nav button */}
          <motion.path
            opacity="0.4"
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M75.9996 69.5003C88.7518 69.9113 99.382 75.805 103 88.0004C106.278 99.0533 96.0749 105.357 87 112.5C76.5961 120.69 68.4999 125 59.4389 121C50.378 117 55.0239 101.325 59.4384 88.0006C63.785 74.8816 62.1458 69.0539 75.9996 69.5003Z"
            fill="#A29B8B"
            animate={isHoverLeft ? "hover" : "notHover"}
            variants={{
              hover: {
                scale: 1.2,
                rotate: -30,
              },
              notHover: { scale: 1, rotate: 0 },
            }}
          />
          <motion.path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M70.3434 68.1698C82.8652 66.6431 95.1433 75.5875 98.4434 87.8454C101.388 98.783 92.1384 107.984 82.7409 114.22C74.8933 119.428 64.447 121.27 57.2554 115.177C50.9987 109.876 55.2946 100.765 57.5018 92.8373C60.2534 82.9546 60.2239 69.4037 70.3434 68.1698Z"
            fill="#191414"
            animate={isHoverLeft ? "hover" : "notHover"}
            variants={{
              hover: {
                scale: 1.1,
                rotate: -40,
              },
              notHover: { scale: 1, rotate: 0 },
            }}
            onMouseEnter={() => setIsHoverLeft(true)}
            onMouseLeave={() => setIsHoverLeft(false)}
            onClick={handlePreviousBtn}
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M77.3707 97.4918C77.6423 97.0109 77.4726 96.4009 76.9917 96.1293C75.4902 95.2814 74.3132 94.3899 73.5263 93.6224C73.1316 93.2374 72.8536 92.9016 72.6815 92.6355C72.5637 92.4532 72.5221 92.3446 72.5076 92.3014C72.5153 92.2792 72.5287 92.2445 72.5517 92.196C72.6132 92.0663 72.7158 91.8948 72.8661 91.6847C73.166 91.2653 73.5991 90.7702 74.1016 90.262C75.1183 89.2336 76.2969 88.2732 77.0009 87.8654C77.4788 87.5886 77.6419 86.9768 77.3651 86.4989C77.0883 86.021 76.4765 85.8579 75.9985 86.1347C75.0776 86.6681 73.7563 87.7665 72.6793 88.8558C72.135 89.4064 71.6229 89.9848 71.2392 90.5213C71.0477 90.7891 70.874 91.0661 70.7446 91.339C70.6226 91.5962 70.4999 91.9317 70.4999 92.2942C70.4999 92.8205 70.7436 93.3216 71.002 93.7213C71.2791 94.15 71.6652 94.6009 72.1298 95.0542C73.0617 95.9631 74.3847 96.954 76.0082 97.8708C76.4891 98.1424 77.0991 97.9727 77.3707 97.4918Z"
            fill="#CCC4B3"
          />
          <defs>
            <filter
              id="filter0_f_3933_36625"
              x="-196.157"
              y="-23.3953"
              width="485.157"
              height="453.395"
              filterUnits="userSpaceOnUse"
              color-interpolation-filters="sRGB"
            >
              <feFlood flood-opacity="0" result="BackgroundImageFix" />
              <feBlend
                mode="normal"
                in="SourceGraphic"
                in2="BackgroundImageFix"
                result="shape"
              />
              <feGaussianBlur
                stdDeviation="20"
                result="effect1_foregroundBlur_3933_36625"
              />
            </filter>
            <motion.pattern
              id="pattern0"
              patternContentUnits="objectBoundingBox"
              width="1"
              height="1"
              patternUnits="objectBoundingBox"
            >
              <use width="1" height="1" xlinkHref="#img_1" />
            </motion.pattern>
            <filter
              id="filter1_f_3933_36625"
              x="20.8433"
              y="45.6047"
              width="485.157"
              height="453.395"
              filterUnits="userSpaceOnUse"
              color-interpolation-filters="sRGB"
            >
              <feFlood flood-opacity="0" result="BackgroundImageFix" />
              <feBlend
                mode="normal"
                in="SourceGraphic"
                in2="BackgroundImageFix"
                result="shape"
              />
              <feGaussianBlur
                stdDeviation="20"
                result="effect1_foregroundBlur_3933_36625"
              />
            </filter>
            <pattern
              id="pattern1"
              patternContentUnits="objectBoundingBox"
              width="1"
              height="1"
            >
              <use xlinkHref="#img_2" />
            </pattern>
            <filter
              id="filter2_f_3933_36625"
              x="236.843"
              y="-60.3953"
              width="485.157"
              height="453.395"
              filterUnits="userSpaceOnUse"
              color-interpolation-filters="sRGB"
            >
              <feFlood flood-opacity="0" result="BackgroundImageFix" />
              <feBlend
                mode="normal"
                in="SourceGraphic"
                in2="BackgroundImageFix"
                result="shape"
              />
              <feGaussianBlur
                stdDeviation="20"
                result="effect1_foregroundBlur_3933_36625"
              />
            </filter>
            <pattern
              id="pattern2"
              patternContentUnits="objectBoundingBox"
              width="1"
              height="1"
            >
              <use xlinkHref="#img_3" />
            </pattern>
            <clipPath id="clip0_3933_36625">
              <rect
                width="216"
                height="216"
                fill="white"
                transform="translate(0 141)"
              />
            </clipPath>
            <clipPath id="clip1_3933_36625">
              <rect
                width="216"
                height="216"
                fill="white"
                transform="translate(217 210)"
              />
            </clipPath>
            <clipPath id="clip2_3933_36625">
              <rect
                width="216"
                height="216"
                fill="white"
                transform="translate(434 105)"
              />
            </clipPath>
            <image
              width="1"
              height="1"
              id="img_1"
              xlinkHref={imageArray[1]}
            ></image>
            <image
              width="1"
              height="1"
              id="img_2"
              xlinkHref={imageArray[2]}
            ></image>
            <image
              width="1"
              height="1"
              id="img_3"
              xlinkHref={imageArray[3]}
            ></image>
          </defs>
        </motion.svg>
      </div>
    </div>
  );
};

export default WhiteListedCollectionsHome;
